// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"styles_form-wrapper__lCHW_","form":"styles_form__2X7yP","inputs":"styles_inputs__2xjK2","buttons":"styles_buttons__1xAgd"};